import { useState, useEffect } from 'react';

export interface ProjectHistoryItem {
  id: string;
  time: string;
  user: {
    name: string;
    avatar: string;
    role: string;
  };
  module: string;
  moduleIcon: string;
  moduleColor: string;
  action: string;
  content: string;
  oldValue: string;
  newValue: string;
}

export function useProjectHistory() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setData({
        history: [
          { id: '1', time: '30/05/2024 10:30:21', user: { name: 'Nguyễn Văn An', role: 'Quản lý dự án', avatar: 'https://i.pravatar.cc/150?u=4' }, module: 'Công việc', moduleIcon: 'ri-task-line', moduleColor: 'bg-emerald-50 text-emerald-600', action: 'Cập nhật', content: 'Cập nhật tiến độ công việc "Thi công móng hầm"', oldValue: '65%', newValue: '70%' },
          { id: '2', time: '30/05/2024 09:15:44', user: { name: 'Trần Thị Mai', role: 'Kỹ sư hiện trường', avatar: 'https://i.pravatar.cc/150?u=11' }, module: 'Tài liệu', moduleIcon: 'ri-file-text-line', moduleColor: 'bg-blue-50 text-blue-600', action: 'Thêm mới', content: 'Tải lên tài liệu mới "Biên bản nghiệm thu móng hầm"', oldValue: '-', newValue: 'Bien_ban_nghiem_thu_mong_ham.pdf' },
          { id: '3', time: '29/05/2024 16:45:12', user: { name: 'Lê Hoàng Nam', role: 'Giám sát kỹ thuật', avatar: 'https://i.pravatar.cc/150?u=2' }, module: 'Vật tư', moduleIcon: 'ri-seedling-line', moduleColor: 'bg-orange-50 text-orange-600', action: 'Phê duyệt', content: 'Phê duyệt yêu cầu vật tư "Thép xây dựng D16"', oldValue: 'Chờ duyệt', newValue: 'Đã phê duyệt' },
          { id: '4', time: '29/05/2024 14:22:05', user: { name: 'Phạm Văn Tài', role: 'Giám sát hiện trường', avatar: 'https://i.pravatar.cc/150?u=3' }, module: 'Công việc', moduleIcon: 'ri-task-line', moduleColor: 'bg-emerald-50 text-emerald-600', action: 'Tạo mới', content: 'Tạo công việc mới "Lắp đặt cốt thép sàn tầng 2"', oldValue: '-', newValue: 'Lắp đặt cốt thép sàn tầng 2' },
          { id: '5', time: '28/05/2024 11:08:33', user: { name: 'Vũ Thị Thanh', role: 'Kế toán dự án', avatar: 'https://i.pravatar.cc/150?u=12' }, module: 'Chi phí', moduleIcon: 'ri-money-dollar-circle-line', moduleColor: 'bg-rose-50 text-rose-600', action: 'Thanh toán', content: 'Thanh toán chi phí "Thanh toán đợt 3 cho NCC An Phát"', oldValue: 'Đã phát sinh', newValue: 'Đã thanh toán' },
          { id: '6', time: '27/05/2024 17:30:50', user: { name: 'Nguyễn Văn An', role: 'Quản lý dự án', avatar: 'https://i.pravatar.cc/150?u=4' }, module: 'Tiến độ', moduleIcon: 'ri-bar-chart-line', moduleColor: 'bg-purple-50 text-purple-600', action: 'Cập nhật', content: 'Cập nhật tiến độ dự án "Khu đô thị Eco Garden"', oldValue: '55%', newValue: '58%' },
        ],
        moduleDistribution: [
          { label: 'Công việc', count: 78, percent: 32, color: 'bg-emerald-500' },
          { label: 'Tài liệu', count: 45, percent: 18, color: 'bg-blue-500' },
          { label: 'Vật tư', count: 34, percent: 14, color: 'bg-amber-500' },
          { label: 'Chi phí', count: 28, percent: 11, color: 'bg-rose-500' },
          { label: 'Tiến độ', count: 20, percent: 8, color: 'bg-purple-500' },
          { label: 'Thiết bị', count: 15, percent: 6, color: 'bg-sky-500' },
          { label: 'Khác', count: 8, percent: 3, color: 'bg-slate-300' },
        ]
      });
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return { data, isLoading };
}
